import { render } from "./Main.vue?vue&type=template&id=09001ce6&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=09001ce6&lang=less&scoped=true"
import "./Main.vue?vue&type=style&index=1&id=09001ce6&lang=less"
script.render = render
script.__scopeId = "data-v-09001ce6"

export default script